import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledInfoCardContainer = styled(Box, {
  display: 'flex',
  overflow: 'hidden',
  padding: '$8',
  position: 'relative',
  scrollbarWidth: 'none',  /* Firefox */

  '&::-webkit-scrollbar': {
    display: 'none' /* Safari and Chrome */,
  },

  variants: {
    hasBorder: {
      true: {
        borderRadius: '$radii$4',
        border: '$borderWidths$1 solid $seafoam500',
      },
    },
    separator: {
      top: {
        borderTop: '$borderWidths$1 solid $seafoam500',
      },
      right: {
        borderRight: '$borderWidths$1 solid $seafoam500',
      },
      bottom: {
        borderBottom: '$borderWidths$1 solid $seafoam500',
      },
      left: {
        borderLeft: '$borderWidths$1 solid $seafoam500',
      },
    },
  },
});
